/* src/app/indirect-jobs/presenters/indirect-jobs-presenters.component.scss */
.indirect-jobs-tree .p-treetable {
  font-size: 12px !important;
}
.indirect-jobs-tree .p-treetable .p-treetable-thead > tr > th {
  background: #45454b !important;
  color: #ffffff !important;
  padding: 0.5rem !important;
  border-right: 1px dotted var(--p-content-border-color, #d1d5db) !important;
  white-space: nowrap;
}
.indirect-jobs-tree .p-treetable .p-treetable-tbody > tr > td {
  padding: 0.25rem !important;
  border-right: 1px dotted var(--p-content-border-color, #d1d5db) !important;
  overflow: visible !important;
  white-space: nowrap;
}
.indirect-jobs-tree .p-treetable .p-treetable-thead > tr > th:last-child,
.indirect-jobs-tree .p-treetable .p-treetable-tbody > tr > td:last-child {
  border-right: none !important;
}
.indirect-jobs-tree .p-dropdown {
  width: 100% !important;
  height: 2rem !important;
  min-height: unset !important;
}
.indirect-jobs-tree .p-dropdown .p-dropdown-label {
  padding: 0.25rem 0.5rem !important;
  font-size: 12px;
  line-height: 1.5;
}
.indirect-jobs-tree .p-dropdown .p-dropdown-trigger {
  width: 1.5rem !important;
}
.indirect-tree-toggler-icon {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 14px;
  border: 1px solid var(--p-content-border-color, #9ca3af);
  border-radius: 2px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  padding: 0.25rem;
  color: var(--p-text-muted-color, #6b7280);
  background-color: var(--p-content-border-color, #d1d5db);
}
.boolean-cell {
  text-align: center !important;
  vertical-align: middle !important;
}
.spin {
  animation: indirect-spin 1s linear infinite;
}
@keyframes indirect-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
/*# sourceMappingURL=indirect-jobs-presenters.component.css.map */
